export default __webpack_public_path__ + "static/media/define3.20f6e3db.png";